export default __webpack_public_path__ + "../staticImages/sprite-dhlgogreen-2x.png";